export default {"src":"/_next/static/media/public-icon.1fbb3f14.svg","height":20,"width":22};